import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import {
  ToastProvider as RadixToastProvider,
  ToastViewport,
  Toast,
  ToastTitle,
} from '@/components/Toast';
import { registerToast } from '@/utils/toastManager';

const ToastContext = createContext({
  toast: () => {},
});

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((message, { duration = 3000 } = {}) => {
    const id = Math.random().toString(36).substring(2, 9);
    setToasts((prev) => [...prev, { id, message, duration }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, duration);
  }, []);

  // Register the toast function with the toast manager
  useEffect(() => {
    registerToast(toast);
  }, [toast]);

  return (
    <ToastContext.Provider value={{ toast }}>
      <RadixToastProvider>
        {children}
        {toasts.map(({ id, message, duration }) => (
          <Toast key={id} duration={duration} className="z-[1000]">
            <ToastTitle>{message}</ToastTitle>
          </Toast>
        ))}
        <ToastViewport className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[1000] flex items-center justify-center p-6" />
      </RadixToastProvider>
    </ToastContext.Provider>
  );
};

export default ToastProvider; 